import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  Title,
);

const LineChart = ({ data, responsive = true, plugins, scales, layout }) => {
  const options = {
    interaction: {
      mode: "nearest",
      intersect: false,
    },
    responsive: responsive,
    plugins: plugins,
    scales: scales,
    layout: layout,
    elements: {
      point: {
        radius: 2,
      },
      line: {
        borderWidth: 2,
        tension: 0.4,
      },
    },
  };

  return <Line options={options} data={data} />;
};

export default LineChart;
